function fireLoggedInEvent(meData, organizationData, selectedOrganizationId) {
    const event = new CustomEvent('loggedIn', {
        detail: { meData, organizationData, selectedOrganizationId },
    });
    document.querySelector('html').dispatchEvent(event);
}

export { fireLoggedInEvent };
